



























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InputOTP from '@/app/ui/components/InputOTP/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import LionParcelLogo from '@/app/ui/assets/lion_parcel_logo.vue'
import IconArrowLeft from '@/app/ui/assets/ics_o_arrow_left.vue'
import Ics_f_warning_circle_red from '@/app/ui/assets/ics_f_warning_circle_red.vue';
import AuthController from '@/app/ui/controllers/AuthController'
import { ExchangeOTPRequest, RequestLibertaOTP } from '@/data/payload/api/AuthRequest'
import { recaptchaV3 } from '@/app/infrastructures/misc/RecaptchaV3';
import dayjs from 'dayjs';
import MainController from '@/app/ui/controllers/MainController';
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue';

@Component({
  components: {
    InputOTP,
    Button,
    LoadingOverlay,
    LionParcelLogo,
    IconArrowLeft,
    Ics_f_warning_circle_red
  }
})
class VerifyLoginOTP extends Vue {
  controller = AuthController;
  challengeToken = "";
  otpErrorMessage= "";
  email = "";
  isErrorRequestOTP = false;
  otpId = 0;
  otp = "";
  canRequestOTP = false;
  countDownInterval: any = null
  requestOtpCountdown = '03 : 00.'
  disabled = false;
  requestOtpErrorMessage = "";
  isLoading = false;

  get isOTPValid(): boolean {
    return this.otp.length === 6
  }

  async created() {
    this.otp = "";
    if (this.$route.query.token) {
      this.challengeToken = String(this.$route.query.token);
      const existingCountdown = Number(localStorage.getItem('otp-countdown'));
      const now = new Date();
      const isExceed = existingCountdown - now.getTime() <= 0;
      const otpId = Number(this.$route.query.otp_id) || 0;
      const email = String(this.$route.query.email) || "";
      if (otpId) this.otpId = otpId;
      if (email) this.email = email;
      if (existingCountdown && !isExceed) {
        return this.setOTPCountDown();
      };
      if (isExceed) {
        this.canRequestOTP = true;
      }
      if (!otpId) {
        localStorage.removeItem("otp-countdown");
        this.handleRequestOTP();
      }
    } else {
      this.$router.replace("/login");
    }
  }

  setOTPCountDown(second = 120): void {
    this.canRequestOTP = false
    const existingCountdown = localStorage.getItem('otp-countdown')
    let retryCountdown = new Date(
      dayjs()
        .add(second, 'seconds')
        .toISOString()
    ).getTime()
    if (existingCountdown) {
      retryCountdown = Number(existingCountdown)
    }
    localStorage.setItem('otp-countdown', retryCountdown.toString())
    this.countDownInterval = setInterval(() => {
      const now = new Date().getTime()
      this.requestOtpCountdown = dayjs(retryCountdown - now).format(
        'mm : ss.'
      )
      if (now >= retryCountdown && this.countDownInterval) {
        this.canRequestOTP = true
        clearInterval(this.countDownInterval)
      }
    }, 1)
  }

  handleEnter() {
    if (this.isOTPValid) this.handleVerify();
  }

  async handleVerify() {
    try {
      this.isLoading = true;
      this.otpErrorMessage = "";
      const resp = await this.controller.verify2FAOTP(new ExchangeOTPRequest({
        otp: this.otp,
        otpId: this.otpId,
        challengeToken: this.challengeToken
      }))

      if (resp.accessToken) {
        this.controller.setAuthData({ auth: resp, email: "" })
        this.controller.getMe()
        MainController.connectShipmentWebsocket();
      }
    } catch (error) {
      const messageEn = error?.data?.message?.en || "";
      const messageId = error?.data?.message?.id || "";
      this.otpErrorMessage = messageId;
      if (messageEn && messageEn.includes('OTP code is no longer valid. Click resend to get a new code.')) {
        this.canRequestOTP = true
      }
    } finally {
      this.isLoading = false;
    }
  }

  async handleRequestOTP() {
    try {
      this.isLoading = true;
      this.otpErrorMessage = "";
      this.otp = '';
      this.requestOtpErrorMessage = "";
      this.isErrorRequestOTP = false;
      const captcha = await recaptchaV3.executeRecaptcha()

      const resp = await this.controller.request2FAOTP(
        new RequestLibertaOTP({
          captcha,
          challengeToken: this.challengeToken
        })
      );
      localStorage.removeItem("otp-countdown")

      this.otpId = resp.otpId;
      this.email = resp.username;
      this.setOTPCountDown(resp.cooldownIn);

      this.$router.replace({
        query: {
          ...this.$route.query,
          otp_id: String(this.otpId),
          email: String(this.email)
        }
      })
    } catch (error) {
      if (error?.data?.message) this.requestOtpErrorMessage = error.data.message.id;
      this.isErrorRequestOTP = true;
      this.canRequestOTP = true;
      if (this.countDownInterval) clearInterval(this.countDownInterval)
      this.$notify({
        title: 'Request OTP Failed',
        text:
          [400, 422, 401, 423].includes(error.status) ? error.error.message.id : 'Something wrong',
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.isLoading = false;
    }
  }

  async handleBack() {
    localStorage.removeItem("otp-countdown");
    await this.$nextTick();
    this.$router.replace("/login");
  }
}
export default VerifyLoginOTP;
